import { render, staticRenderFns } from "./StudentEnrollments.vue?vue&type=template&id=43f4a6c4"
import script from "./StudentEnrollments.vue?vue&type=script&lang=js"
export * from "./StudentEnrollments.vue?vue&type=script&lang=js"
import style0 from "./StudentEnrollments.vue?vue&type=style&index=0&id=43f4a6c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports